import React, { useEffect } from 'react';
import { MdCheck } from "react-icons/md";
import { AiOutlineMinus } from "react-icons/ai";



type IProps = {
  label?: string | JSX.Element,
  isChecked?: boolean,
  onChange?: (e: any) => void
  isClickWidthOutLabel?: boolean,
  isCheckboxReadOnly?: boolean,
  isRounded?: boolean,
  customCheckboxLabelStyle?: string,
  customIconStyle?: string | React.CSSProperties,
  intermediate?: boolean,
}
const CustomCheckbox: React.FC<IProps> = ({ label, isChecked, onChange, customIconStyle, isClickWidthOutLabel = false, isCheckboxReadOnly = false, isRounded = false, customCheckboxLabelStyle, intermediate = false }) => {

  const samsungBrowser = !!navigator.userAgent.match(/SamsungBrowser/i);

  // Generate a unique id for the checkbox
  const checkboxId = React.useMemo(() => {
    if (typeof label === 'string') {
      return `checkbox-${label.replace(/\s+/g, '-').toLowerCase()}`;
    }
    return `checkbox-${Math.random().toString(36).substr(2, 9)}`;
  }, [label]);
  
  return (
    <div className={`form-checkbox ${isCheckboxReadOnly ? 'cursor-not-allowed' : ''} ${isRounded ? 'form-checkbox-rounded' : ''}`}>
      <input type="checkbox" id={checkboxId} checked={isChecked} onChange={onChange} className={`${isClickWidthOutLabel ? 'input-click-without-label' : ''}`} />
      <div className={`form-input-checkbox ${customIconStyle ? customIconStyle : ''} ${samsungBrowser ? 'samsung-checkbox' : ''}`}>
        {/* <MdCheck /> */}
       {intermediate ? <AiOutlineMinus /> : <MdCheck />}
      </div>
      {label ? <label htmlFor={checkboxId} className={`form-input-label ${customCheckboxLabelStyle ? customCheckboxLabelStyle : ''}`}>{label}</label> : null}
    </div>
  );
};

export default CustomCheckbox;
